import { render } from "./InteractiveAttachmentModal.vue?vue&type=template&id=ca8d04ce&scoped=true"
import script from "./InteractiveAttachmentModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./InteractiveAttachmentModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./InteractiveAttachmentModal.vue?vue&type=style&index=0&id=ca8d04ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca8d04ce"]])

export default __exports__